import type { FlexProps} from '@chakra-ui/react'
import { Flex, FormLabel, Switch } from '@chakra-ui/react'
import { flexGroupListContext } from 'BrokerTsLib/src/context'
import { useContext } from 'react'

import { SearchField } from '@/components'

export const FlexGroupListFilter = (props: FlexProps) => {
  const { filter, updateFilter, setCurrentPage } =
    useContext(flexGroupListContext)

  return (
    <Flex
      sx={{ display: 'flex', gap: 4, justifyContent: 'space-between' }}
      {...props}
    >
      <SearchField
        onSearch={(search) => updateFilter({ ...filter, name: search })}
      />

      <Flex sx={{ gap: 4, alignItems: 'center' }}>
        <Switch
          id="showInvalid"
          isChecked={filter.showInvalid}
          onChange={() => {
            updateFilter({ ...filter, showInvalid: !filter.showInvalid })
            setCurrentPage(1)
          }}
        />
        <FormLabel htmlFor="showInvalid" variant="switch">
          Zobrazit i neaktivní
        </FormLabel>
      </Flex>
    </Flex>
  )
}
